import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';
import { Localizacao } from './localizacao.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LocalizacaoService {

  localizacao: Localizacao = new Localizacao();
  url: string = environment.ipApiURL

  constructor(private http: HttpClient) { }

  getLocalizacao(): Observable<Localizacao> {
    return this.http.get<Localizacao>(this.url);
  }

  getLocalizacaoCustum() {
    return this.http.get<any>('https://ipapi.co/json/').pipe(
      catchError(() => {
        return this.http.get<any>('https://api.ipapi.is/?key=fb5115ad314029d06d67').pipe(
          catchError(() => this.http.get<any>('https://geo.ipify.org/api/v2/country,city?apiKey=at_etHmtKythPpo2mVIm2howgMgozuX5'))
        );
      })
    );
  }

  mapearParaLocalizacao(dados: any): Localizacao {
    const loc = new Localizacao();

    if (dados?.location && dados?.asn) {
      // API ipapi.is
      loc.ip = dados.ip || '';
      loc.city = dados.location.city || '';
      loc.region = dados.location.state || '';
      loc.region_code = '';
      loc.country_name = dados.location.country || '';
      loc.country_code = dados.location.country_code || '';
      loc.country_code_iso3 = '';
      loc.country_capital = '';
      loc.network = dados.company?.network || dados.asn?.route || '';
      loc.version = 'IPv4'; // assumido
      loc.continent_code = dados.location.continent || '';
      loc.in_eu = dados.location.is_eu_member || false;
      loc.postal = dados.location.zip || '';
      loc.latitude = dados.location.latitude || 0;
      loc.longitude = dados.location.longitude || 0;
      loc.timezone = dados.location.timezone || '';
      loc.utc_offset = '';
      loc.country_calling_code = `+${dados.location.calling_code || ''}`;
      loc.currency = dados.location.currency_code || '';
      loc.currency_name = '';
      loc.languages = '';
      loc.country_area = 0;
      loc.country_population = 0;
      loc.asn = dados.asn.asn?.toString() || '';
      loc.org = dados.asn.org || dados.company?.name || '';
    }
    else if (dados?.location && dados?.as) {
      // API geo.ipify.org
      loc.ip = dados.ip || '';
      loc.city = dados.location.city || '';
      loc.region = dados.location.region || '';
      loc.region_code = '';
      loc.country_code = dados.location.country || '';
      loc.country_name = '';
      loc.country_code_iso3 = '';
      loc.country_capital = '';
      loc.continent_code = '';
      loc.in_eu = false;
      loc.postal = dados.location.postalCode || '';
      loc.latitude = dados.location.lat || 0;
      loc.longitude = dados.location.lng || 0;
      loc.timezone = dados.location.timezone || '';
      loc.utc_offset = '';
      loc.country_calling_code = '';
      loc.currency = '';
      loc.currency_name = '';
      loc.languages = '';
      loc.country_area = 0;
      loc.country_population = 0;
      loc.network = dados.as.route || '';
      loc.asn = dados.as.asn?.toString() || '';
      loc.org = dados.as.name || '';
      loc.version = 'IPv4';
    }
    else {
      // API ipapi.co
      loc.ip = dados.ip;
      loc.network = dados.network;
      loc.version = dados.version;
      loc.city = dados.city;
      loc.region = dados.region;
      loc.region_code = dados.region_code;
      loc.country = dados.country;
      loc.country_name = dados.country_name;
      loc.country_code = dados.country_code;
      loc.country_code_iso3 = dados.country_code_iso3;
      loc.country_capital = dados.country_capital;
      loc.country_tld = dados.country_tld;
      loc.continent_code = dados.continent_code;
      loc.in_eu = dados.in_eu;
      loc.postal = dados.postal;
      loc.latitude = dados.latitude;
      loc.longitude = dados.longitude;
      loc.timezone = dados.timezone;
      loc.utc_offset = dados.utc_offset;
      loc.country_calling_code = dados.country_calling_code;
      loc.currency = dados.currency;
      loc.currency_name = dados.currency_name;
      loc.languages = dados.languages;
      loc.country_area = dados.country_area;
      loc.country_population = dados.country_population;
      loc.asn = dados.asn;
      loc.org = dados.org;
    }

    return loc;
  }

}
